import React from 'react';
import { connect } from 'react-redux';

import { toggleLoading } from 'stores/actions';

class PhoneInfo extends React.Component {

  render() {
    return (
      <div className="box-footer p-2 pointer" style={{ backgroundColor: '#2e6c99' }} onClick={this.props.onClick}>
        <div className="bg-white p-2 mt-2">
          <div className="row align-items-center">
            <div className="col-md">
              <span className="font-weight-bold mr-1">Incoming call:</span>
              <h5 className="mb-0 mt-1">{this.props.phone}</h5>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( PhoneInfo );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/PhoneInfo/index.js